var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "participant-list-component" }, [
    _c(
      "div",
      { staticClass: "participant-list-component-header" },
      [
        !_vm.isShowSearchForm
          ? [
              _c("div", { staticClass: "controls" }, [
                _c(
                  "div",
                  { staticClass: "control sort" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "control-text title",
                        on: {
                          click: function ($event) {
                            return _vm.toggleControlModal("sort")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("user.parti.sort")))]
                    ),
                    _c("GrmMenu", {
                      staticClass: "control-modal",
                      attrs: {
                        open: _vm.isShowModal.sort,
                        list: _vm.sortControlList,
                      },
                      on: {
                        "update:open": function ($event) {
                          return _vm.$set(_vm.isShowModal, "sort", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm.hasEmceeRole()
                  ? _c(
                      "div",
                      { staticClass: "control auth" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "control-text title",
                            on: {
                              click: function ($event) {
                                return _vm.toggleControlModal("auth")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("user.parti.auth")))]
                        ),
                        _c("GrmMenu", {
                          staticClass: "control-modal auth",
                          attrs: {
                            "text-align": "left",
                            open: _vm.isShowModal.auth,
                            list: _vm.authControlList,
                          },
                          on: {
                            "update:open": function ($event) {
                              return _vm.$set(_vm.isShowModal, "auth", $event)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm.lmsUserList.length > 0
                ? _c("div", { staticClass: "controls items-center" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "text-xs px-2 py-1 bg-white font-bold border rounded border-gray-300",
                        on: {
                          click: function ($event) {
                            return _vm.onSendSMS("all")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("user.parti.allSendSms")))]
                    ),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "search" }, [
                _c("button", {
                  staticClass: "search-button",
                  on: { click: _vm.toggleSearchForm },
                }),
              ]),
            ]
          : [
              _c("div", { staticClass: "search-form" }, [
                _c("div", { staticClass: "search-input-wrapper" }, [
                  _c("input", {
                    ref: "searchInput",
                    staticClass: "search-input",
                    attrs: {
                      type: "text",
                      placeholder: _vm.$t("user.parti.searchName"),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.searchRoomUser($event.target.value)
                      },
                    },
                  }),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "search-cancel",
                    on: { click: _vm.toggleSearchForm },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                ),
              ]),
            ],
      ],
      2
    ),
    _c(
      "div",
      {
        ref: "participantList",
        staticClass: "participant-list-component-body",
        on: {
          drop: [
            _vm.onDrop,
            function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
            },
          ],
          dragenter: function ($event) {
            $event.preventDefault()
          },
          dragend: _vm.onDragEnd,
          dragstart: function ($event) {
            $event.preventDefault()
          },
          dragover: function ($event) {
            $event.preventDefault()
          },
          dragleave: function ($event) {
            $event.preventDefault()
          },
        },
      },
      [
        _c("div", { staticClass: "h-full overflow-y-auto" }, [
          _c(
            "ul",
            {
              staticClass: "room-user-list",
              class: { clickable: _vm.hasEmceeRole() },
            },
            [
              _vm._l(_vm.filteredParticipants, function (participant) {
                return _c(
                  "li",
                  {
                    key: participant.id,
                    staticClass: "room-user-item",
                    attrs: {
                      "data-userId": participant.userId,
                      draggable:
                        !_vm.isWebinarLive &&
                        _vm.hasEmceeRole() &&
                        !_vm.Device.isMobile(),
                    },
                    on: {
                      dragstart: (event) => _vm.onDragStart(event, participant),
                    },
                  },
                  [
                    _c("div", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value:
                            _vm.isP2PCallType || participant.layoutSeqNum > -1
                              ? _vm.$t("user.parti.video.receiving")
                              : _vm.$t("user.parti.video.reject"),
                          expression:
                            "isP2PCallType || participant.layoutSeqNum > -1 ? $t('user.parti.video.receiving') : $t('user.parti.video.reject')",
                          modifiers: { top: true },
                        },
                      ],
                      staticClass: "room-user-join-device border-l-4",
                      class: [
                        participant.deviceType,
                        {
                          "border-primary":
                            _vm.isP2PCallType || participant.layoutSeqNum > -1,
                        },
                      ],
                    }),
                    _c(
                      "div",
                      { staticClass: "room-user-info" },
                      [
                        _vm.isOpener(participant.userId)
                          ? _c("GrmIcon", {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.top",
                                  value: _vm.$t("common.opener"),
                                  expression: "$t('common.opener')",
                                  modifiers: { top: true },
                                },
                              ],
                              staticClass: "mr-1",
                              attrs: { icon: "opener", pointerEvents: "auto" },
                            })
                          : _vm._e(),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.top",
                                value: participant.nickname,
                                expression: "participant.nickname",
                                modifiers: { top: true },
                              },
                            ],
                            staticClass: "room-user-nickname",
                            class: { me: _vm.isMe(participant.userId) },
                            on: {
                              click: function ($event) {
                                return _vm.changeUserNickname(participant)
                              },
                            },
                          },
                          [_vm._v(_vm._s(participant.nickname))]
                        ),
                        _c(
                          "GrmMark",
                          {
                            staticClass: "ml-1 grm-mark",
                            attrs: {
                              "data-user-role": participant.roomUserRole.roleId,
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.userRoleName(
                                  participant.roomUserRole.roleId,
                                  true
                                )
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("button", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: _vm.deviceTooltip(participant, "screen"),
                          expression: "deviceTooltip(participant, 'screen')",
                          modifiers: { top: true },
                        },
                      ],
                      staticClass: "room-user-device screen",
                      class: [
                        { none: !_vm.hasDeviceRole(participant, "screen") },
                        {
                          active:
                            participant.userId ===
                            _vm.getScreenShareUser?.userId,
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.onPermissionChangeClick(
                            participant,
                            "screen"
                          )
                        },
                      },
                    }),
                    _c("button", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: _vm.deviceTooltip(participant, "camera"),
                          expression: "deviceTooltip(participant, 'camera')",
                          modifiers: { top: true },
                        },
                      ],
                      staticClass: "room-user-device camera",
                      class: [
                        participant.cameraStatus,
                        { none: !_vm.hasDeviceRole(participant, "camera") },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.onPermissionChangeClick(
                            participant,
                            "camera"
                          )
                        },
                      },
                    }),
                    _c("button", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: _vm.deviceTooltip(participant, "mic"),
                          expression: "deviceTooltip(participant, 'mic')",
                          modifiers: { top: true },
                        },
                      ],
                      staticClass: "room-user-device mic",
                      class: [
                        participant.micStatus,
                        { none: !_vm.hasDeviceRole(participant, "mic") },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.onPermissionChangeClick(participant, "mic")
                        },
                      },
                    }),
                    _c("button", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: _vm.deviceTooltip(participant, "draw"),
                          expression: "deviceTooltip(participant, 'draw')",
                          modifiers: { top: true },
                        },
                      ],
                      staticClass: "room-user-device draw",
                      class: { none: !participant.roomUserRole.draw },
                      on: {
                        click: function ($event) {
                          return _vm.onPermissionChangeClick(
                            participant,
                            "draw"
                          )
                        },
                      },
                    }),
                    _vm.hasEmceeRole()
                      ? _c(
                          "div",
                          { staticClass: "room-user-more" },
                          [
                            _c("button", {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.top",
                                  value: _vm.deviceTooltip(participant, "more"),
                                  expression:
                                    "deviceTooltip(participant, 'more')",
                                  modifiers: { top: true },
                                },
                              ],
                              staticClass: "more-button",
                              on: {
                                click: function ($event) {
                                  return _vm.toggleUserMore(participant)
                                },
                              },
                            }),
                            _c("transition", { attrs: { name: "fade" } }, [
                              _vm.isShowMoreModal[participant.userId]
                                ? _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "click-outside",
                                          rawName: "v-click-outside",
                                          value: () => {
                                            _vm.toggleUserMore(participant)
                                          },
                                          expression:
                                            "() => { toggleUserMore(participant) }",
                                        },
                                      ],
                                      ref: "moreModal",
                                      refInFor: true,
                                      staticClass: "room-user-more-modal",
                                      class: { fixed: _vm.isFixedMoreModal },
                                    },
                                    [
                                      _c(
                                        "ul",
                                        { staticClass: "room-user-role-list" },
                                        [
                                          _c(
                                            "li",
                                            {
                                              staticClass:
                                                "room-user-role-item",
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "room-user-role-button",
                                                  class: {
                                                    selected:
                                                      participant.roomUserRole
                                                        .roleId === "speaker",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.setRoleId(
                                                        participant,
                                                        "speaker"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.userRoleName(
                                                        "speaker"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "li",
                                            {
                                              staticClass:
                                                "room-user-role-item",
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "room-user-role-button",
                                                  class: {
                                                    selected:
                                                      participant.roomUserRole
                                                        .roleId === "emcee",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.setRoleId(
                                                        participant,
                                                        "emcee"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.userRoleName("emcee")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "li",
                                            {
                                              staticClass:
                                                "room-user-role-item",
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "room-user-role-button",
                                                  class: {
                                                    selected:
                                                      participant.roomUserRole
                                                        .roleId ===
                                                      "participant",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.setRoleId(
                                                        participant,
                                                        "participant"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.userRoleName(
                                                        "participant"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          !_vm.isMe(participant.userId)
                                            ? _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "room-user-role-item",
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "room-user-role-button kick",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.kickUser(
                                                            participant
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "user.parti.kickUser.title"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "room-user-browser-info",
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "room-user-browser-info-text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.osInfo(participant))
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "room-user-browser-info-text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.clientInfo(participant)
                                                )
                                              ),
                                            ]
                                          ),
                                          participant.deviceModel
                                            ? _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "room-user-browser-info-text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      participant.deviceModel
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          participant.networkType
                                            ? _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "room-user-browser-info-text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      participant.networkType
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                )
              }),
              _vm.hasEmceeRole()
                ? _vm._l(_vm.lmsUserList, function (lmsUser) {
                    return _c(
                      "li",
                      {
                        key: lmsUser.userId,
                        staticClass: "room-user-item bg-gray-200",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "room-user-info px-2 flex justify-between items-center",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "text-sm font-bold text-gray-400",
                                staticStyle: { "font-size": "12px" },
                              },
                              [_vm._v(" " + _vm._s(lmsUser.username) + " ")]
                            ),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "text-xs px-2 py-1 bg-white font-bold border rounded border-gray-300",
                                on: {
                                  click: function ($event) {
                                    return _vm.onSendSMS(lmsUser)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("user.parti.sendSms")))]
                            ),
                          ]
                        ),
                      ]
                    )
                  })
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }